import { Observable } from "rxjs";
import { AddMasterPlanLocationRequest } from "../../domain";
import { MasterPlansRepository } from "../../repositories";
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";

@Injectable({ providedIn: 'root' })
export class AddMasterPlanLocationUsecase implements UseCase<AddMasterPlanLocationRequest, boolean> {

    constructor(private readonly masterPlanRepository: MasterPlansRepository) {
    }

    execute(params: AddMasterPlanLocationRequest): Observable<boolean> {
        return this.masterPlanRepository.addMasterPlanLocation(params);
    }

}